var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 11.8777C14.592 12.4262 15.5282 13.3065 16.2116 14.4072C16.3469 14.6252 16.4145 14.7342 16.4379 14.8851C16.4855 15.1918 16.2757 15.5689 15.9901 15.6903C15.8495 15.75 15.6914 15.75 15.3751 15.75M12.0001 8.64918C13.1114 8.09692 13.8751 6.95015 13.8751 5.625C13.8751 4.29985 13.1114 3.15308 12.0001 2.60082M10.5001 5.625C10.5001 7.48896 8.98908 9 7.12512 9C5.26116 9 3.75012 7.48896 3.75012 5.625C3.75012 3.76104 5.26116 2.25 7.12512 2.25C8.98908 2.25 10.5001 3.76104 10.5001 5.625ZM1.91954 14.2038C3.11527 12.4084 5.00215 11.25 7.12512 11.25C9.24809 11.25 11.135 12.4084 12.3307 14.2038C12.5926 14.5971 12.7236 14.7937 12.7085 15.0449C12.6968 15.2405 12.5686 15.48 12.4123 15.5982C12.2116 15.75 11.9355 15.75 11.3834 15.75H2.86689C2.31475 15.75 2.03868 15.75 1.83795 15.5982C1.68166 15.48 1.55344 15.2405 1.5417 15.0449C1.52662 14.7937 1.65759 14.5971 1.91954 14.2038Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers03);
export default __webpack_public_path__ + "static/media/users-03.7307360bfe01d06e30d14bbb16ddc72c.svg";
export { ForwardRef as ReactComponent };